import { useState, useEffect, useRef } from 'react';
import $ from 'jquery';
import _ from 'underscore';
import EverTrue from 'app';
import AdminGateStore from 'apps/admin/stores/admin-gate-store';
import PagedColTable from 'components/tables/paged-col-table';
import { AdvancedCombobox, Button, Loading } from '@evertrue/et-components';
import Dropdown from 'components/controls/dropdown';
import Pagination from 'components/controls/pagination';
import str from 'underscore.string';

const AdminGatingController = () => {
  const [state, setState] = useState({
    orgs: {},
    filter: undefined,
    loading: true,
    features: [],
    all_features: [],
  });

  const searchRef = useRef(null);
  const featureRef = useRef(null);
  const isMounted = useRef(true);

  useEffect(() => {
    AdminGateStore.initialize();

    const updateOrgs = (orgs) => {
      if (isMounted.current) setState((prev) => ({ ...prev, orgs }));
    };

    const updateFeatures = (names) => {
      if (isMounted.current) setState((prev) => ({ ...prev, features: names, all_features: names }));
    };

    AdminGateStore.bindToUpdates(updateOrgs);
    AdminGateStore.getFeatures(updateFeatures);
    AdminGateStore.getOrgs().then(getResultGates);

    return () => {
      isMounted.current = false;
      AdminGateStore.unbind();
    };
  }, []);

  const getResultGates = () => {
    if (isMounted.current) setState((prev) => ({ ...prev, loading: true }));
    AdminGateStore.getGates().then(() => {
      if (isMounted.current) setState((prev) => ({ ...prev, loading: false }));
    });
  };

  const handleOrgSearch = () => {
    const filter = searchRef.current.value;
    AdminGateStore.filter(filter).then(getResultGates);
  };

  const handleResetSearch = () => {
    searchRef.current.value = '';
    handleOrgSearch();
  };

  const handleFeatureFilter = () => {
    const key = featureRef.current.value;
    setState((prev) => ({
      ...prev,
      features: _.filter(prev.all_features, (gate) => _.isEmpty(key) || gate.toLowerCase().includes(key.toLowerCase())),
    }));
  };

  const handlePage = (page) => {
    AdminGateStore.getOrgs(page).then(getResultGates);
    $(document).scrollTop(0);
  };

  const handleGateSelect = (enabled, gate) => {
    $('body').trigger('click'); // closeDropdowns
    const message = `Are you sure you want to ${
      enabled ? 'enable' : 'disable'
    } all user and organization gates for this feature (${str.humanize(gate)})?`;

    EverTrue.Alert.confirm(message, (confirm) => {
      if (!confirm) return;
      if (isMounted.current) setState((prev) => ({ ...prev, loading: true }));
      AdminGateStore.deprecateGate(gate).then(() => {
        AdminGateStore.updateDefaultGate(gate, enabled).then(getResultGates);
      });
    });
  };

  const handleSingleUpdate = (key, org, value) => {
    const platforms = value === 'none' ? undefined : value.split('|');
    AdminGateStore.updateGate(key, org.id, platforms);
  };

  function header(gate) {
    return (
      <Dropdown icon_label="true" label={str.titleize(str.humanize(gate.split('.').join('_')))}>
        <ul className="menu menu--bordered">
          <li>
            <a href="#" onClick={() => handleGateSelect(true, gate)}>
              Enable all on iOS & Web
            </a>
          </li>
          <li>
            <a href="#" onClick={() => handleGateSelect(false, gate)}>
              Disable all
            </a>
          </li>
        </ul>
      </Dropdown>
    );
  }

  const rows = {
    org: (data) => (
      <div className="admin-table--org">
        <strong>{data.name || str.titleize(data.slug)}</strong>
        <div>
          <span className="text-label">Slug/OID: </span>
          {data.slug}
        </div>
        <div>
          <span className="text-label">ID: </span>
          {data.id}
        </div>
      </div>
    ),
    gate: (data, column) => (
      <AdvancedCombobox
        options={[
          { value: 'ios', label: 'Enabled on iOS' },
          { value: 'web', label: 'Enabled on Web' },
          { value: 'ios|web', label: 'Enabled on iOS & Web' },
          { value: 'none', label: 'Disabled' },
        ]}
        value={{ value: AdminGateStore.getFeatureValue(column.key, data) }}
        onChange={(selectedObj) => handleSingleUpdate(column.key, data, selectedObj.value)}
      />
    ),
  };

  return (
    <div className="page-container admin-page-body">
      <h1 className="admin-title" tabIndex={-1}>
        Features By Org
      </h1>
      <div className="module">
        {state.loading ? (
          <Loading />
        ) : (
          <>
            <div className="module--header clearfix">
              <input
                type="text"
                className="admin-table--search pull-left"
                placeholder="Search by organization name or oid"
                ref={searchRef}
              />
              <Button className="pull-left" onClick={handleOrgSearch}>
                Search
              </Button>
              <Button type="secondary" className="pull-left" onClick={handleResetSearch}>
                Reset
              </Button>

              <input
                type="text"
                className="admin-table--feature-filter pull-right"
                placeholder="Filter Features"
                ref={featureRef}
                onKeyUp={handleFeatureFilter}
              />
            </div>

            <PagedColTable
              className="admin-table"
              data={state.orgs.items || []}
              syncing={state.loading}
              rows={rows}
              columns={[
                { label: 'Organization', row: 'org', sticky: true, width: 250 },
                ...state.features.map((gate) => ({
                  label: header(gate),
                  row: 'gate',
                  key: gate,
                })),
              ]}
              columnWidth={200}
              sortable={false}
            />
            <Pagination
              className="admin-table--pagination"
              page={state.orgs.page}
              total={state.orgs.total / (state.orgs.limit || 25)}
              onChange={handlePage}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default AdminGatingController;
